import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class Catalogs_ds_material_catalogs_project_subscribers_gridService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { catalog_id: number }): 
  Promise<{ result: { ProjectId?: number, MaterialCatalogId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, materials?: { material_count?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.catalog_id)) {
      missingRequiredInParams.push('\'catalog_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalogs_project_subscribers_grid/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { catalog_id: number, $top?: number, $skip?: number }): 
  Promise<{ result: { ProjectId?: number, MaterialCatalogId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, materials?: { material_count?: number } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.catalog_id)) {
      missingRequiredInParams.push('\'catalog_id\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalogs_project_subscribers_grid/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { catalog_id: number, $keys: { ProjectId?: number, MaterialCatalogId?: number }[] }): 
  Promise<{ result: { ProjectId?: number, MaterialCatalogId?: number, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, materials?: { material_count?: number } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.catalog_id)) {
      missingRequiredInParams.push('\'catalog_id\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/Catalogs/datasources/ds_material_catalogs_project_subscribers_grid/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      catalog_id: number    }) {
        if(isNil(inParams.catalog_id)) {
          return true; 
        }
      return false;
    }
}
